export default "__VITE_ASSET__DZeaZ3ye__"